<template>
  <div id="app">
    <Navbar />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Navbar from './components/NavBar'
import Footer from './components/Footer'

export default {
  name: 'App',
  components: {
    Navbar, Footer
  }
}
</script>

<style>
  body {
    margin: 0;
    background: rgba(243, 243, 246, 1);
  }
</style>
